'use client'

import { useEffect, useRef } from 'react'
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext'
import { $getRoot, $createParagraphNode, $createTextNode } from 'lexical'
import { parseNotationString } from './SerializationPlugin'
import { $createMentionNodeFromData } from './notationNodes'

export default function InitializationPlugin({ initialValue }) {
    const [editor] = useLexicalComposerContext()
    const initialized = useRef(false)

    useEffect(() => {
        if (initialized.current) return
        initialized.current = true
        if (!initialValue) return

        editor.update(() => {
            const root = $getRoot()
            root.clear()

            const lines = initialValue.split('\n')

            lines.forEach(line => {
                const paragraph = $createParagraphNode()
                const segments = parseNotationString(line)

                if (segments.length === 0) {
                    paragraph.append($createTextNode(''))
                } else {
                    segments.forEach(segment => {
                        if (segment.type === 'text') {
                            paragraph.append($createTextNode(segment.value))
                        } else if (segment.type === 'mention') {
                            paragraph.append($createMentionNodeFromData(segment.value))
                        }
                    })
                }

                root.append(paragraph)
            })
        })
    }, [editor, initialValue])

    return null
}
